/**
 * Codes of the keys that triggered the onkeypress event,
 * or the Unicode key code of the keys that triggered the
 * onkeydown or onkeyup event.
 */

export const KEYCODES = {
  ESCAPE: 27,
  ENTER: 13,
  TAB: 9,
};
